import {dd,store,app} from 'systems/imports'

import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

/**
 */
class Util extends BaseApi{
  static getClassName(){ return 'Util' }

  /**
   */
  static userAgent(input){
    return app.make("axios").get(`v1/util/user-agent`,input)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }
}
export default Util



// WEBPACK FOOTER //
// ./src/api/Util.js